export const MB_TO_BYTES = 1024 * 1024

export const MAX_PREVIEW_SIZE_ALLOWED = 15 * MB_TO_BYTES
export const MAX_UPLOAD_SIZE_ALLOWED = 50 * MB_TO_BYTES
